import React from 'react';

const PlayerStatsTable = ({ children }) => (
  <section className="s-advanced-stats__data s-advanced-stats__players">
    <div className="stats-table__fixed-container">
      <div className="stats-table__container">
        <table className="stats-table">{children}</table>
      </div>
    </div>
  </section>
);

export default PlayerStatsTable;
